import storage from "./storage";

function logoutUser() {
  const redirect = window.location.pathname;
  // Defer importing actions to avoid circular init issues with store
  import("../views/Auth/store/actions")
    .then(({ setRedirect, logout }) => {
      try {
        // Only save redirect for regular user routes
        if (redirect !== "/login" && !redirect.startsWith("/admin")) {
          setRedirect(redirect);
        }
        logout();
      } catch (e) {
        console.error(e);
      }
    })
    .catch(() => {});

  // Clear auth token and role
  storage.clearToken();
  storage.clearRole();
  // Also clear persisted Redux state to ensure a clean boot
  try {
    window.localStorage.removeItem("persist:root");
  } catch (_) {}

  // No forced reload. App state (Redux) reset via logout() action will trigger UI updates/redirects.
}

export default logoutUser;
